import {Trans} from '@lingui/macro';
import React, {useCallback, useState} from 'react';
import styled, {css} from 'styled-components';

import {CustomFieldModel} from '../../../models/api/customFieldModel';
import {SettingsSidebarInfoBox} from '../../common/settingsSidebarInfoBox';
import {CustomFieldImpactOnRule} from '../customFieldImpactOnRule';

/*
 * Types.
 */

interface CustomFieldEditSidebarProps {
  customField: CustomFieldModel;
}

/*
 * Styles.
 */

interface StyledSettingsSidebarInfoBoxProps {
  $isVisible: boolean;
}

const StyledSettingsSidebarInfoBox = styled(SettingsSidebarInfoBox)<StyledSettingsSidebarInfoBoxProps>`
  ${(p) => addInfoBoxOpacity(p.$isVisible)}
`;

function addInfoBoxOpacity(isVisible: boolean) {
  if (isVisible) {
    return css`
      opacity: 1;
    `;
  }
  return css`
    opacity: 0;
  `;
}

/*
 * Component.
 */

export const CustomFieldEditSidebar = ({customField}: CustomFieldEditSidebarProps) => {
  const [shouldDisplayImpactedRules, setShouldDisplayImpactedRules] = useState(false);

  const onImpactedRulesFetchedCallback = useCallback(
    (totalRules: number) => {
      setShouldDisplayImpactedRules(totalRules > 0);
    },
    [setShouldDisplayImpactedRules],
  );

  return (
    <StyledSettingsSidebarInfoBox
      $isVisible={shouldDisplayImpactedRules}
      title={<Trans id="settings-edit-custom-field-infobox-title">Impact of this custom field</Trans>}
      body={
        <ul>
          <li>
            <Trans id="settings-edit-custom-field-infobox-description">Affects</Trans>{' '}
            <CustomFieldImpactOnRule
              customField={customField}
              onImpactedRulesFetched={onImpactedRulesFetchedCallback}
            />
          </li>
        </ul>
      }
    />
  );
};
